import React from 'react';
import '../styles/stepIndicator.scss';

const STEPS = [
  { id: 1, label: 'الشروط' },
  { id: 2, label: 'البيانات' },
  { id: 3, label: 'التأكيد' }
];

export const StepIndicator = ({ currentStep }) => {
  return (
    <ol className="step-indicator">
      {STEPS.map((step, index) => {
        const status =
          step.id === currentStep
            ? 'current'
            : step.id < currentStep
            ? 'done'
            : 'upcoming';

        return (
          <li key={step.id} className={`step-indicator__item ${status}`}>
            <span className="step-indicator__circle">
              {status === 'done' ? '✓' : step.id}
            </span>
            <span className="step-indicator__label">{step.label}</span>
            {index < STEPS.length - 1 && <span className="step-indicator__line" />}
          </li>
        );
      })}
    </ol>
  );
};

export default StepIndicator;
